/* eslint-disable react/no-unescaped-entities */
import { FC } from 'react';
import { GithubFilled } from '@ant-design/icons';
import styled from 'styled-components';

import { MpLink } from 'shared/ui/MpLink';
import { MpOl } from 'shared/ui/MpOl';
import { MpParagraph } from 'shared/ui/MpParagraph';
import { MpText } from 'shared/ui/MpText';
import LogoDE from './LogoDE.svg?react';

const DescriptionHeadingStyled = styled.h2`
	margin-top: 30px;
	margin-bottom: 12px;
	font-size: 20px;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		margin-top: 48px;
		margin-bottom: 24px;
		font-size: 24px;
	}
`;

const ParagraphStyled = styled(MpParagraph)`
	margin-bottom: 12px;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		margin-bottom: 24px;
	}
`;

const ListContainerStyled = styled.div`
	margin-bottom: 32px;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		margin-bottom: 48px;
	}
`;

const LinksContainerStyled = styled.div`
	gap: 12px;
	display: flex;
	flex-direction: column;
	margin-bottom: 32px;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		margin-bottom: 48px;
	}
`;

const DescriptionSubheadingStyled = styled.h3`
	margin-bottom: 12px;
	font-size: 16px;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		margin-bottom: 24px;
	}
`;

export const Intg1CDescription: FC = () => (
	<section>
		<DescriptionHeadingStyled>Описание шаблона</DescriptionHeadingStyled>
		<ParagraphStyled>
			Расширение конфигурации 1С:Бухгалтерия предприятия выгружает данные о продажах из Dodo IS и формирует
			документы в 1С. Позволяет загружать данные о поступлениях, перемещении товаров, расходе материалов, выпуске
			продукции и розничных продажах.
			<br />
			<br />
			Работает с платформой 1С:Предприятие 8.3 (8.3.22.2239)
			<br />
			Конфигурация: Бухгалтерия предприятия КОРП, редакция 3.0 (3.0.138.25).
			<br />
			<br />
			Написана компанией{` `}
			<MpLink url='https://consult-inform.com/' text='Консалт-Информ' />
			{` `}
			для корпоративных розничных сетей Додо Пицца, Дринкит и Донер 42, которые обслуживает бухгалтерия
			Управляющей Компании.
		</ParagraphStyled>
		<ListContainerStyled>
			<MpParagraph style={{ marginBottom: `12px` }}>Два модуля в архиве:</MpParagraph>
			<MpOl style={{ gap: `12px`, marginBottom: `24px` }}>
				<li>
					<MpText>Авторизация и получение данных по API</MpText>
				</li>
				<li>
					<MpText>Формирование учетных документов, на основе данных API</MpText>
				</li>
			</MpOl>
			<MpParagraph>Предусмотрены функции по переезду с базы старого модуля.</MpParagraph>
		</ListContainerStyled>
		<DescriptionSubheadingStyled>Ссылки для разработчика:</DescriptionSubheadingStyled>
		<LinksContainerStyled>
			<div style={{ display: `flex`, gap: `8px`, alignItems: `center` }}>
				<LogoDE style={{ fontSize: `24px`, width: `24px` }} />
				<MpLink url='https://pyrus.com/form/1241436' text='Форма для получения доступа к API Dodo IS' />
			</div>
			<div style={{ display: `flex`, gap: `8px`, alignItems: `center` }}>
				<GithubFilled style={{ fontSize: `24px` }} />
				<div style={{ marginTop: `1px` }}>
					<MpLink url='https://github.com/dodobrands/1c-accounting-export' text='Исходный код модуля' />
				</div>
			</div>
		</LinksContainerStyled>
	</section>
);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const Intg1CDescription_eng: FC = () => (
	<section>
		<DescriptionHeadingStyled>Description of the Template</DescriptionHeadingStyled>
		<ParagraphStyled>
			The 1C:Accounting enterprise configuration extension extracts sales data from Dodo IS and generates
			documents in 1C. It allows for loading data on receipts, movement of goods, consumption of materials,
			production output, and retail sales.
			<br />
			<br />
			Works with 1C:Enterprise 8.3 (8.3.22.2239) platform.
			<br />
			Configuration: Enterprise Accounting CORP, version 3.0 (3.0.138.25).
			<br />
			<br />
			Developed by <MpLink url='https://consult-inform.com/' text='Consult-Inform' /> for corporate retail
			networks Dodo Pizza, Drinkit, and Doner 42, serviced by the accounting department of the Managing Company.
		</ParagraphStyled>
		<ListContainerStyled>
			<MpParagraph style={{ marginBottom: `12px` }}>Two modules in the archive:</MpParagraph>
			<MpOl style={{ gap: `12px`, marginBottom: `24px` }}>
				<li>
					<MpText>Authorization and data retrieval through API</MpText>
				</li>
				<li>
					<MpText>Generation of accounting documents based on API data</MpText>
				</li>
			</MpOl>
			{/* eslint-disable-next-line react/no-unescaped-entities */}
			<MpParagraph>Functions for migrating from the old module's database are provided.</MpParagraph>
		</ListContainerStyled>
		<DescriptionSubheadingStyled>Developer Links:</DescriptionSubheadingStyled>
		<LinksContainerStyled>
			<div style={{ display: `flex`, gap: `8px`, alignItems: `center` }}>
				<LogoDE style={{ fontSize: `24px`, width: `24px` }} />
				<MpLink url='https://pyrus.com/form/1241436' text='Form to Access Dodo IS API' />
			</div>
			<div style={{ display: `flex`, gap: `8px`, alignItems: `center` }}>
				<GithubFilled style={{ fontSize: `24px` }} />
				<div style={{ marginTop: `1px` }}>
					<MpLink url='https://github.com/dodobrands/1c-accounting-export' text='Module Source Code' />
				</div>
			</div>
		</LinksContainerStyled>
	</section>
);
